import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './slicess/rootReducer';

const Store = configureStore({
    reducer: rootReducer
})

export default Store;